module.exports = __webpack_public_path__ + "static/media/business-team-ideas.2178c5af.svg";